var map = {
	"./Menu-1.jpg": 65,
	"./Menu-10.jpg": 66,
	"./Menu-11.jpg": 67,
	"./Menu-12.jpg": 68,
	"./Menu-13.jpg": 69,
	"./Menu-2.jpg": 70,
	"./Menu-3.jpg": 71,
	"./Menu-4.jpg": 72,
	"./Menu-5.jpg": 73,
	"./Menu-6.jpg": 74,
	"./Menu-7.jpg": 75,
	"./Menu-8.jpg": 76,
	"./Menu-9.jpg": 77,
	"./Menu-dimsum-BG.jpg": 78,
	"./Menu-dimsum-BG2.jpg": 79
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;